import React from "react";
import Navbar from "../components/Navbar";
import { useTranslation, Trans } from "react-i18next";
import Seo from "../components/Seo";

const Support = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const isMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 480px)").matches;

  const pageStyle = {
    backgroundColor: "#1C1C17",
    color: "white",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  };

  const contentStyle = {
    maxWidth: "800px",
    width: "100%",
    margin: "0 auto",
    padding: "20px",
    boxSizing: "border-box",
  };

  const titleContainerStyle = {
    textAlign: "center",
    padding: isMobile() ? "90px 0 20px" : "90px 0 40px",
  };

  const titleStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const lastUpdatedStyle = {
    fontSize: "0.9rem",
    opacity: "0.7",
  };

  const subtitleStyle = {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginTop: "30px",
    marginBottom: "15px",
  };

  const textStyle = {
    fontSize: "1rem",
    lineHeight: "1.6",
    marginBottom: "15px",
  };

  const listStyle = {
    paddingLeft: isRTL ? "0" : "18px",
    paddingRight: isRTL ? "15px" : "0",
    marginBottom: "15px",
  };

  const linkStyle = {
    color: "#4DA8DA",
    textDecoration: "none",
  };

  return (
    <div style={pageStyle}>
      <Seo
        title="Support | Nightly"
        description="Contact Nightly support for help with your account, app issues, and general support requests."
        path="/support"
      />
      <Navbar />
      <div style={contentStyle}>
        <div style={titleContainerStyle}>
          <h1 style={titleStyle}>{t("support_page.title")}</h1>
          <p style={lastUpdatedStyle}>{t("support_page.last_updated")}</p>
        </div>

        <p style={textStyle}>{t("support_page.introduction_text")}</p>

        <h2 style={subtitleStyle}>{t("support_page.contact_title")}</h2>
        <p style={textStyle}>
          <Trans
            i18nKey="support_page.contact_text"
            components={{
              email: (
                <a
                  href="mailto:support@nightly.co?subject=Nightly%20Support%20Request"
                  style={linkStyle}
                >
                  support@nightly.co
                </a>
              ),
            }}
          />
        </p>

        <h2 style={subtitleStyle}>{t("support_page.response_title")}</h2>
        <p style={textStyle}>{t("support_page.response_text")}</p>

        <h2 style={subtitleStyle}>{t("support_page.help_topics_title")}</h2>
        <p style={textStyle}>{t("support_page.help_topics_text")}</p>
        <ul style={listStyle}>
          <li>{t("support_page.help_topics_list_1")}</li>
          <li>{t("support_page.help_topics_list_2")}</li>
          <li>{t("support_page.help_topics_list_3")}</li>
          <li>{t("support_page.help_topics_list_4")}</li>
        </ul>

        <h2 style={subtitleStyle}>{t("support_page.include_title")}</h2>
        <p style={textStyle}>{t("support_page.include_text")}</p>
        <ul style={listStyle}>
          <li>{t("support_page.include_list_1")}</li>
          <li>{t("support_page.include_list_2")}</li>
          <li>{t("support_page.include_list_3")}</li>
        </ul>

        <h2 style={subtitleStyle}>{t("support_page.languages_title")}</h2>
        <p style={textStyle}>{t("support_page.languages_text")}</p>
      </div>
    </div>
  );
};

export default Support;
